import { ErrorInfo } from 'react'
import { User } from '../../../types/user-types'

export default function handleAPIError(error: Error | any, info: ErrorInfo, user: User | null = null) {
  // Check if the error is like an instance of Error, or a string error message, or default to 'Unknown error'
  const errorMessage = error?.message || (typeof error === 'string' ? error : 'Unknown error')
  console.error(`Message: ${errorMessage}`)
  console.error(`Component Stack: ${info?.componentStack}`)
  if (user) {
    console.error(`User ID: ${user.id}`)
  }
}
